<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow v-for="assistant in assistantList" :key="assistant.id">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">
                            {{ assistant.title }}
                        </CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="assistantEnabled[assistant.id]"
                            />
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';

    export default {

        name: 'PartnerAssistant',
        components: {
            PartnersTabLinks,
        },

        data() {
            return {
                partner: {},
                assistantList: [],
                assistantEnabled: [],
            };
        },

        computed: {},

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    const partner = resp.data;
                    if (!partner.assistant) partner.assistant = [];
                    this.partner = partner;
                    Vue.axios
                        .get('/assistants/')
                        .then(resp => {
                            this.assistantList = resp.data;
                            this.initAssistantEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            save() {
                this.partner.assistant = [];
                for (var i = 0; i < this.assistantList.length; i++) {
                    if (this.assistantEnabled[this.assistantList[i].id]) {
                        this.partner.assistant.push(this.assistantList[i].id);
                    }
                }
                Vue.axios
                    .put('/partners/' + this.partner.id + '/assistant', {
                        assistant: this.partner.assistant,
                    })
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            initAssistantEnabled() {
                this.assistantEnabled = [];
                for (var i = 0; i < this.assistantList.length; i++) {
                    this.assistantEnabled[
                        this.assistantList[i].id
                    ] = this.partner.assistant.includes(this.assistantList[i].id);
                }
            },
            goBack() {
                this.$router.push({ path: '/partners/' + this.partner.id });
            },
        },
    };
</script>
